import { render, staticRenderFns } from "./authPin.vue?vue&type=template&id=0f6aab6c&scoped=true"
import script from "./authPin.vue?vue&type=script&lang=js"
export * from "./authPin.vue?vue&type=script&lang=js"
import style0 from "./authPin.vue?vue&type=style&index=0&id=0f6aab6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6aab6c",
  null
  
)

export default component.exports